import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-1',
  templateUrl: './1.component.html',
  styleUrls: ['./1.component.scss'],
})
export class VbTablesBootstrap1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
